import styles from './Button.module.scss';

/**
 * Button 컴포넌트
 * - 공용 버튼 컴포넌트
 * - variant, size, className을 통해 스타일 커스터마이징 가능
 *
 * @param {string} variant - 버튼 스타일 변형 ('primary' | 'secondary' | 'danger' | 'default')
 * @param {string} size - 버튼 크기 ('small' | 'medium' | 'large')
 * @param {string} className - 추가 CSS 클래스
 * @param {boolean} disabled - 비활성화 여부
 * @param {React.ReactNode} children - 버튼 내용
 * @param {Function} onClick - 클릭 핸들러
 * @param {string} type - 버튼 타입 ('button' | 'submit' | 'reset')
 * @param {object} rest - 기타 HTML button 속성
 */
function Button({
  variant = 'default',
  size = 'medium',
  className = '',
  disabled = false,
  children,
  onClick,
  type = 'button',
  ...rest
}) {
  const buttonClasses = [styles.button, styles[variant], styles[size], className]
    .filter(Boolean)
    .join(' ');

  return (
    <button type={type} className={buttonClasses} disabled={disabled} onClick={onClick} {...rest}>
      {children}
    </button>
  );
}

export default Button;
